export const isProfitWellStarted = state => {
    return state.trackers['profitWell'];    
}